export default __webpack_public_path__ + "static/v-day-banner-424cbd845fd0afb8f5d3b8baff433672.jpg";